module.exports = __webpack_public_path__ + "img/restart_button.f9fc3fa3.png";